import {observable, action} from 'mobx';
import co from 'co';
import * as gs from 'js/utils/api/googlespreadsheet';
import DB from './db';

/**
 * App Store
 */
export default class AppStore {
  @observable ready = {db: false, page: false, action: true};
  @observable step = {aggregate: false, regist: false};
  @observable error = false;
  @observable questions = [];
  @observable breadcrumbsLevel = 0;
  @observable scrollTopButton = false; // true: on, false: off

  /**
   * constructor
   */
  constructor() {
    this.db = new DB();
  }

  /**
   * app init
   */
  init() {
    // 無名関数はジェネレーター関数として扱えない
    co(this.initGenerator());
  }

  /**
   * init generator
   */
  * initGenerator() {
    // google spreadsheet を tsv形式で取得
    const result = yield gs.get();
    if (result.error) {
      this.initError();
    } else {
      this.db.import(result.data);
      this.initSuccess();
    }
  }

  /**
   * init success
   */
  @action initSuccess() {
    this.questions = this.db.questions;
    this.ready.db = true;
  }

  /**
   * init error
   */
  @action initError() {
    this.error = true;
    this.ready.db = true;
    this.ready.page = true;
  }

  /**
   * clear error
   */
  @action clearError() {
    this.error = false;
  }

  /**
   * page loading
   */
  @action pageLoading() {
    this.ready.page = false;
    this.ready.action = true;
  }

  /**
   * action loading
   * @param {boolean} view
   */
  @action actionLoading(view) {
    this.ready.action = view;
  }

  /**
   * page loading
   * @param {object} param
   */
  @action pageView(param) {
    // スクロールをトップへ
    window.scrollTo(0, 0);

    // タイトル更新
    document.title = param.title;

    // パンくず更新
    this.breadcrumbsLevel = param.breadcrumbsLevel;

    // ページを表示
    this.ready.page = true;
  }

  /**
   * scroll top button on off
   * @param {boolean} view
   */
  @action scrollTopButtonView(view) {
    if (view == this.scrollTopButton) {
      return;
    }

    this.scrollTopButton = view;
  }

  /**
   * input change
   * @param {object} param
   */
  @action updateQuestionChecked(param) {
    this.db.updateQuestionChecked(param);
    this.questions = this.db.questions;
  }

  /**
   * update step
   * @param {string} type
   * @param {boolean} status
   */
  @action updateStep(type, status) {
    this.step[type] = status;
  }

  /**
   * get app type
   */
  get selectAppType() {
    return this.db.app.type;
  }

  /**
   * get questions all
   * @return {array}
   */
  get selectAllQuestions() {
    return this.db.questions;
  }

  /**
   * get categorys all
   * @return {array}
   */
  get selectAllCategorys() {
    return this.db.categorys;
  }

  /**
   * get phase all
   * @return {array}
   */
  get selectAllPhase() {
    return this.db.selectAllPhaseJoinRangesOrderByRangeDesc();
  }

  /**
   * get phase from id
   * @param {number} id
   * @return {object}
   */
  selectPhaseFromId(id) {
    const result = this.db.select({
      table: 'phase',
      where: 'id',
      value: id,
    });

    return result;
  }

  /**
   * get radar chart
   * @return {object}
   */
  get selectRadarchart() {
    return this.db.radarchart;
  }

  /**
   * get line chart
   * @return {object}
   */
  get selectLinechart() {
    return this.db.linechart;
  }
}



// WEBPACK FOOTER //
// ./src/js/stores/app/index.js